// src/auth/RequireGroup.jsx
import { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

export default function RequireGroup({ allowed, children }) {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { tokens } = await fetchAuthSession();
        const groups = tokens?.idToken?.payload?.['cognito:groups'] || [];

        const ok = allowed.some((g) => groups.includes(g));
        setHasAccess(ok);
      } catch (err) {
        console.error('RequireGroup error:', err);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    })();
  }, [allowed]);

  if (loading) {
    return null; // or a tiny spinner if you want
  }

  if (!hasAccess) {
    return (
      <div style={{ padding: 24 }}>
        <h3 style={{ marginTop: 0 }}>Not authorized</h3>
        <p>You don’t have access to this page.</p>
      </div>
    );
  }

  return children;
}
